<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑会员</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="authlist.length > 1 ? authlist.length : ''" class="item">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回会员管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsMembers'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in authlist" :key="index">
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <label class="TTL-form-label">认证类型<i>*</i></label>
                    <wcselect :option="{placeholder:'请选择认证类型',filterable:true,ischange:true,width:'200px'}" 
                        :value="item.auth_id" 
                        :list="memberauthtypes"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.auth_id=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <div v-if="item.auth_id==1">
                <el-form-item>
                    <label class="TTL-form-label">姓名<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入姓名',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'300px'}" 
                        :value="item.auth_id_name"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.auth_id_name=val.value;
                            }
                            if(val.type=='change') {
                                item.auth_id_name=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">身份证号<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入身份证号',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'300px'}" 
                        :value="item.auth_id_card"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.auth_id_card=val.value;
                            }
                            if(val.type=='change') {
                                item.auth_id_card=val.value;
                            }
                        }"
                    />
                </el-form-item>
                </div>
                <div v-if="item.auth_id==2">
                <el-form-item>
                    <wcupload :option="{size:'large'}" 
                        :value="item.auth_business_license[0]" 
                        class="top20"
                        @finish="(val)=> {
                            item.auth_business_license[0]=val.url;
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">主体名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入主体名称',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'300px'}" 
                        :value="item.auth_business_shopname"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.auth_business_shopname=val.value;
                            }
                            if(val.type=='change') {
                                item.auth_business_shopname=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">主体类型<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入主体类型',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'300px'}" 
                        :value="item.auth_business_shoptype"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.auth_business_shoptype=val.value;
                            }
                            if(val.type=='change') {
                                item.auth_business_shoptype=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">执照注册号<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入执照注册号',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'300px'}" 
                        :value="item.auth_business_node"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.auth_business_node=val.value;
                            }
                            if(val.type=='change') {
                                item.auth_business_node=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">联系电话<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入联系电话',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'300px'}" 
                        :value="item.auth_business_phone"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.auth_business_phone=val.value;
                            }
                            if(val.type=='change') {
                                item.auth_business_phone=val.value;
                            }
                        }"
                    />
                </el-form-item>
                </div>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';
export default {
    components:{},
    data() {
        return {
            Browser:'editmemberauth',
            loadingobj:'editmemberauth',
            limit:10,  //限制添加数据条数
            memberinfo:{auth_id:'',auth_id_name:'',auth_id_card:'',auth_business_license:'',auth_business_shopname:'',auth_business_shoptype:'',auth_business_node:'',auth_business_phone:'',auth_status:'',auth_error_reason:''}, //会员模板信息           
            authlist:[], //会员信息列表
            memberauthtypes:[], //会员认证类型
            verifystatus:[],    //会员认证状态

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetMemberAuthTypes(isfresh);
            this.GetStatusList(isfresh); //获取认证状态
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前有操作正在执行，是否要将其覆盖 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetMemberAuthInfo(data.param.id);
                }).catch(()=> {

                });

            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetMemberAuthInfo(data.param.id);
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.authlist.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个认证信息',type:'warning'});return false;}
            var data=[];
            for(var i in this.authlist) data.push(this.authlist[i]);
            data=JSON.stringify(data);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_MEMBER.SAVE_MEMBER_AUTH_INFO({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.$parent.JUMPVIEW({name:'EsMembers',delname:'EsEditAuth'})
                this.$notice({title:'成功提示',message:'编辑数据成功',type:'success'});
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作


        /** 获取会员信息详情 **/
        GetMemberAuthInfo(id) {
            INTERFACE_MODEL_MEMBER.GET_AUTH_INFO({memberid:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.authlist=[];
                 this.authlist.push(res.data);
            });
        },


        /** 获取会员认证类型 **/
        GetMemberAuthTypes(isfresh) {
            this.$method.GET_MEMBER_AUTH_TYPES(isfresh).then((res) => {this.memberauthtypes=res;console.log(res)});
        },

        /** 获取认证状态信息 **/
        GetStatusList(isfresh) {
            this.$method.GET_MEMBER_AUTH_LOG_STATUS(isfresh).then((res) => {this.verifystatus=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
</style>